<template>
    <div class="form-group">
        <label :for="getId" v-text="getLabel"></label>
        <v-select
                v-model="currentObject"
                :options="videos"
                :loading="isLoading || booting"
                label="name"
                ref="selector"
        >
        </v-select>
    </div>
</template>

<script>
    import fieldInfo from './../mixins/fieldInfo';
    import vSelect from 'vue-select';

    export default {
        components: {
            vSelect
        },
        mixins: [
            fieldInfo,
        ],
        data: function () {
            return {
                booting: true,
                currentObject: null,
            }
        },
        computed: {
            videos() {
                return this.$store.state.composer.videos;
            },
            isLoading() {
                return this.$store.getters.isLoading('videos');
            }
        },
        methods: {
            setObject(video) {
                this.currentValue = video.id;
                this.booting = false;
            }
        },
        watch: {
            currentObject(newValue, oldValue) {
                if (newValue !== oldValue && newValue !== undefined && newValue !== null && newValue !== '') {
                    this.setObject(newValue);
                }
            }
        },
        created() {
            this.$store.dispatch('boot', 'getVideos')
                .then(() => {
                    if (this.videos.length) {
                        // this.setObject(find(this.videos, {'id': this.value});

                        this.booting = false;
                    } else {
                        this.booting = false;
                    }

                    this.currentObject = this.currentValue;
                });
        }
    }
</script>

<style scoped>

</style>
